/**
 * Created by andrey on 05.02.2021.
 */

const RegionsUnits = function () {
    cleverapps.EventEmitter.call(this);

    const fogs = Map2d.currentMap.fogs.getFogRegions();
    this.fogs = fogs.map((code) => new RegionUnit({
        code,
        type: RegionUnit.TYPE_FOG
    }));

    const codes = cleverapps.substract(Object.keys(Map2d.currentMap.regions), fogs).sort();
    codes.push(RegionUnit.CODE_CREATE);
    this.units = codes.map((code) => new RegionUnit({
        code,
        type: RegionUnit.TYPE_REGION
    }), this);
};

RegionsUnits.prototype = Object.create(cleverapps.EventEmitter.prototype);
RegionsUnits.prototype.constructor = RegionsUnits;

RegionsUnits.prototype.getUnits = function (options) {
    switch (options && options.type) {
        case RegionUnit.TYPE_REGION:
            return this.units;
        default:
            return this.fogs;
    }
};

RegionsUnits.prototype.getUnitIcons = function (options) {
    return this.getUnits(options).map((unit) => new RegionUnitIcon(unit));
};

RegionsUnits.prototype.validateCode = function (code) {
    if (/[^a-z0-9_-]/.test(code)) {
        return `Invalid region code: ${code}. The region code must match the regex [a-z0-9_-]`;
    }

    if (Map2d.currentMap.regions[code]) {
        return `Region code ${code} already exists`;
    }

    if (!code) {
        return "Error: empty code";
    }
};

RegionsUnits.prototype.createNewRegion = function () {
    const code = window.prompt("New region code");
    const error = this.validateCode(code);

    if (error) {
        cleverapps.notification.create(error);
        return;
    }

    Editor.currentEditor.doCommand("createRegion", { code });

    const unit = this.units.find((u) => u.code === code);
    Editor.currentEditor.select(unit);
};

RegionsUnits.prototype.renameRegion = function (unit) {
    const oldCode = unit.code;
    const code = window.prompt(`${unit.code} - new region code?`);
    if (unit.code === code) {
        return;
    }

    const error = this.validateCode(code);

    if (error) {
        cleverapps.notification.create(error);
        return;
    }

    Editor.currentEditor.doCommand("renameRegion", { oldCode, code });
    Editor.currentEditor.select(unit);
};

RegionsUnits.prototype.deleteRegion = function (unit) {
    if (!confirm(`Delete region with code "${unit.code}'?`)) {
        return;
    }

    const index = this.units.indexOf(unit);
    if (index === -1) {
        cleverapps.notification.create(`Cant find unit with code ${unit.code}`);
        return;
    }

    Editor.currentEditor.doCommand("deleteRegion", { code: unit.code });
};

RegionsUnits.prototype.clearRegion = function (unit) {
    if (!confirm(`Clear region with code "${unit.code}'?`)) {
        return;
    }

    Editor.currentEditor.doCommand("clearRegion", { code: unit.code });
};

RegionsUnits.prototype.sort = function () {
    this.units.sort((a, b) => a.code.localeCompare(b.code));
};
